import React, { useState } from 'react';
import { FlaskConical, Swords, ShieldCheck, BookOpen, MessageSquareWarning, Microscope } from 'lucide-react';
import { GlassCard } from '@/components/ui/card';
import { TabButton } from './lab/SharedComponents';
import { AttackerMode } from './lab/AttackerMode';
import { DefenderMode } from './lab/DefenderMode';
import { LinguisticsLab } from './lab/LinguisticsLab';
import { MLExplainability } from './lab/MLExplainability';

export const PhishingLab = () => {
  const [activeTab, setActiveTab] = useState('attacker');

  return (
    <div className="space-y-6 sm:space-y-8">
      <div>
        <div className="flex items-center gap-2 sm:gap-3 mb-2">
          <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg sm:rounded-xl bg-gradient-to-br from-destructive/80 to-primary flex items-center justify-center">
            <FlaskConical className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
          </div>
          <div>
            <h2 className="font-display text-xl sm:text-2xl font-bold text-foreground">Phishing Lab</h2>
            <p className="text-xs text-muted-foreground">Adversarial Simulation & Explainable Detection</p>
          </div>
        </div>
        <p className="text-sm text-muted-foreground">
          Explore how attackers craft deceptive URLs and how defenders detect them with transparent, explainable analysis.
        </p>
      </div>

      <div className="flex gap-2 flex-wrap">
        <TabButton active={activeTab === 'attacker'} onClick={() => setActiveTab('attacker')}
          icon={Swords} label="Attacker Mode" testId="tab-attacker" />
        <TabButton active={activeTab === 'defender'} onClick={() => setActiveTab('defender')}
          icon={ShieldCheck} label="Defender Mode" testId="tab-defender" />
        <TabButton active={activeTab === 'linguistics'} onClick={() => setActiveTab('linguistics')}
          icon={MessageSquareWarning} label="Linguistics Lab" testId="tab-linguistics" />
        <TabButton active={activeTab === 'ml'} onClick={() => setActiveTab('ml')}
          icon={Microscope} label="ML Explainability" testId="tab-ml" />
      </div>

      {activeTab === 'attacker' && <AttackerMode />}
      {activeTab === 'defender' && <DefenderMode />}
      {activeTab === 'linguistics' && <LinguisticsLab />}
      {activeTab === 'ml' && <MLExplainability />}

      <GlassCard className="p-4 sm:p-5 border-primary/20 border">
        <div className="flex items-start gap-3">
          <BookOpen className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="text-sm font-semibold mb-1">Educational Purpose</h4>
            <p className="text-xs text-muted-foreground">
              This lab demonstrates phishing techniques for cybersecurity education. Attacker, Defender and
              Linguistics modes run deterministically in your browser; the ML Explainability tab calls the
              local scikit-learn models on the backend. Understanding how attacks work is the first step to defending against them.
            </p>
          </div>
        </div>
      </GlassCard>
    </div>
  );
};

export default PhishingLab;
